import { TimeSeriesSku } from './time-series-sku';

export class TimeSeriesSkuCollection {
  constructor(
    public industry: string,
    public skuCount: number,
    public skus: TimeSeriesSku[]
  ) { }
}
